<template>
  <div>
    <p>Click on the extra smiling face on the left</p>
    <div ref="leftSide"></div>
    <div ref="rightSide"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ref, onMounted } from "vue";
export default {
  name: "Display_MatchGame",
  components: {},
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.generateFaces();
  },
  data() {
    return {
      numberOfFaces: 5,
      theLeftSide: this.$refs.leftSide,
      therightSide: this.$refs.rightSide,
      theBody: document.getElementsByTagName("body")[0]
    };
  },
  computed: {},
  methods: {
    gameOver() {
      alert("Game Over! \n\n The game will restart");
      this.theBody.onclick = null;
      this.theLeftSide.lastChild.onclick = null;
      location.reload();
    },
    generateFaces() {
      this.theLeftSide = this.$refs.leftSide;

      for (var i = 0; i < this.numberOfFaces; i++) {
        var img = document.createElement("img");
        img.src =
          "https://home.cse.ust.hk/~rossiter/mooc/matching_game/smile.png";
        var topValue = Math.floor(Math.random() * 401);
        var leftValue = Math.floor(Math.random() * 401);
        img.style.top = topValue + "px";
        img.style.left = leftValue + "px";
        this.theLeftSide.appendChild(img);
      }

      let leftSideImages = this.theLeftSide.cloneNode(true);
      leftSideImages.removeChild(leftSideImages.lastChild);
      this.therightSide.appendChild(leftSideImages);

      this.theLeftSide.lastChild.onclick = function nextLevel(event) {
        event.stopPropagation();
        while (theLeftSide.firstChild)
          this.theLeftSide.removeChild(this.theLeftSide.firstChild);
        while (this.therightSide.firstChild)
          this.therightSide.removeChild(this.therightSide.firstChild);
        this.numberOfFaces += 2;
        this.generateFaces();
      };

      /*theBody.onclick = function gameOver() {
        alert("Game Over! \n\n The game will restart");
        theBody.onclick = null;
        theLeftSide.lastChild.onclick = null;
        location.reload();
      };*/
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  position: absolute;
  width: 500px;
  height: 500px;
}

img {
  position: absolute;
}

#rightSide {
  left: 500px;
  border-left: 2px solid black;
}
</style>
